import React, { Component } from 'react';
import AnimatedBtnExample from 'styleguide/components/animated_btn';

const ExampleButtons = () =>
  <section id="buttons">
    <h3 className="section-header">Buttons</h3>
    <div className="row">
      <div className="columns small-16">
        <button className="btn btn-primary">Primary Button</button> <button className="btn btn-primary" disabled>Primary Button Disabled</button><br/>
        <button className="btn btn-secondary">Secondary Button</button> <button className="btn btn-secondary" disabled>Secondary Button Disabled</button><br/>
        <button className="btn btn-text">Text Only Button</button><br/>
      </div>
    </div>
    <div className="row">
      <div className="columns small-16">
        <button className="btn btn-primary btn-with-icon"><i className="fa fa-plus"></i>Left Icon Button</button><br/>
        <button className="btn btn-utility btn-icon-only btn-sm"><i className="fa fa-eye"></i></button> Icon Only Button
      </div>
    </div>
    <div className="row">
      <div className="columns small-16">
        <button className="btn btn-primary btn-block">Full Width Button</button>
        <button className="btn btn-primary btn-half">Half Width Button</button>
        <button className="btn btn-text btn-half last">Half Width Button</button>
      </div>
    </div>
    <div className="row">
      <div className="columns small-16">
        <AnimatedBtnExample />
      </div>
    </div>

  </section>;

export { ExampleButtons }



// WEBPACK FOOTER //
// ./styleguide/components/buttons.jsx